/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

// Import jQuery for tender form functionality
import $ from 'jquery';

//= require ./markdown_editor

window.Tenders = {
  initializeCurrency() {
    $(document).on('change', '#tender_currency', function () {
      const selected = $('#tender_currency :selected');
      return $('.currency').html(selected.val());
    });
    return $('#tender_currency').change();
  },

  setServiceFeeAndTotalFee() {
    let base_fee = $('#tender_fee').val();
    base_fee = isNaN(parseFloat(base_fee)) || (parseFloat(base_fee) < 0) ? 0 : base_fee;
    const total_service_fee = base_fee <= 0 ? 0 : this.serviceFee * base_fee;
    const total_fee = parseFloat(base_fee) + parseFloat(total_service_fee);
    $('#service_fee').html(this.formatPrice(total_service_fee, ',', null, 2));
    return $('#total_fee').html(this.formatPrice(total_fee, ',', null, 2));
  },

  formatPrice(f, delimiter, separator, precision, stripzero) {
    let s = undefined;
    delimiter = delimiter || '';
    separator = separator || '.';
    if ((precision === 0) || precision) {
      s = f.toFixed ? f.toFixed(precision) : f.toString();
    } else {
      s = f.toString();
    }
    if (stripzero) {
      s = s.replace(/(\.[^0]*)0+$/, '$1');
    }
    if (separator && (separator !== '.')) {
      s = s.replace(/(\.[^0]*)0+$/, '$1');
    }
    if ((delimiter !== '') || (separator !== '.')) {
      const parts = s.split('.');
      if (delimiter !== '') {
        parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + delimiter);
      }
      s = parts.join(separator);
    }
    return s;
  },

  initializeFeeType() {
    if ($('#tender_fee_type_owner').is(':checked')) {
      $('#breakdown-row, #collection-row').hide();
      $('select#tender_fee_type').attr('disabled', true);
    }
    if ($('#tender_issuer_fee_method_online').is(':checked')) {
      $('#tender_payment_instructions').hide();
    }
    $('input[type=\'radio\'][name=\'tender[fee_type]\']').on('click', function () {
      if ($('#tender_fee_type_owner').is(':checked')) {
        $('#breakdown-row, #collection-row').hide();
        return $('select#tender_fee_type').attr('disabled', true);
      } else if ($('#tender_fee_type_').is(':checked')) {
        $('#breakdown-row, #collection-row').show();
        return $('select#tender_fee_type').removeAttr('disabled');
      }
    });
    return $('input[type=\'radio\'][name=\'tender[issuer_fee_method]\']').on('click', function () {
      if ($('#tender_issuer_fee_method_online').is(':checked')) {
        return $('#tender_payment_instructions').hide();
      } else if ($('#tender_issuer_fee_method_bank').is(':checked')) {
        return $('#tender_payment_instructions').show();
      }
    });
  },

  initializeFeeCalculation() {
    return $(document).on('keyup', '#tender_fee', () => {
      return this.setServiceFeeAndTotalFee();
    });
  },

  initializeReference() {
    $('#tender_reference_with_project_true').on('click', function () {
      $('#reference_without_project').find('#tender_reference').attr('disabled', true);
      $('#reference_with_project').find('#tender_reference').attr('disabled', false);
      $('#reference_with_project').find('#tender_reference').attr('name', 'tender[reference]');
      return $('#reference_without_project').find('#tender_reference').attr('name', '');
    });
    return $('#tender_reference_with_project_false').on('click', function () {
      $('#reference_with_project').find('#tender_reference').attr('disabled', true);
      $('#reference_without_project').find('#tender_reference').attr('disabled', false);
      $('#reference_without_project').find('#tender_reference').attr('name', 'tender[reference]');
      return $('#reference_with_project').find('#tender_reference').attr('name', '');
    });
  },

  initializeNewForm(serviceFee) {
    this.serviceFee = serviceFee;
    this.initializeCurrency();
    this.initializeFeeCalculation();
    this.setServiceFeeAndTotalFee();
    this.initializeFeeType();
    this.initializeReference();
    MarkdownEditor.initialize('#tender_remarks');
    return MarkdownEditor.initialize('#tender_description');
  }
};
